import { shouldShowTimeRange, formatDeliveryDateForDisplay } from "common/utils/format/date";

// MN-9575: the conservative_generic_pdp_estimate flag (surfaced by the delivery
// ERB partial as window.jiffy.flip.conservativeGenericPdpEstimate) gates whether
// the frontend softens firm "Today/Tomorrow" copy for generic (no-destination)
// estimates. Mirrors the backend gate in EstimatePdpDates#suppress_generic_optimism?.
export const isConservativeGenericEstimateEnabled = () =>
  window?.jiffy?.flip?.conservativeGenericPdpEstimate === true;

// True when a delivery response is a generic (no real customer destination)
// estimate AND the conservative flag is on, so firm copy should be softened.
export const shouldSoftenGenericEstimate = deliveryDates =>
  deliveryDates?.generic_estimate === true && isConservativeGenericEstimateEnabled();

// Strip the firm "Today"/"Tomorrow" relative prefix from a single delivery date
// segment, keeping the calendar date (e.g. "Tomorrow, Jun 18" -> "Jun 18").
const softenSegment = segment => {
  if (!shouldShowTimeRange(segment)) return formatDeliveryDateForDisplay(segment);
  const commaIndex = segment.indexOf(",");
  // No calendar part to fall back on (e.g. a bare "Tomorrow"); leave as-is.
  return commaIndex === -1 ? segment : segment.slice(commaIndex + 1).trim();
};

// Soften firm "Today"/"Tomorrow" copy across a (possibly multi-shipment) value,
// e.g. "Today, Jun 18 & Tomorrow, Jun 19" -> "Jun 18 & Jun 19". A generic
// estimate is computed against a hub default zip, so it cannot honestly promise
// same-day/next-day delivery. Each " & " segment is softened independently so a
// relative day in a later segment is not leaked or swallowed.
export const softenGenericDeliveryDate = value => {
  if (!value) return value;
  return value.split(" & ").map(softenSegment).join(" & ");
};
